import { FC, PropsWithChildren, useEffect } from "react";
import { useLatestExchangeRates, usePrematchSports, useLiveSports, useSportResults } from "hooks";
import { scrollToTop } from "utils/helpers";

const GlobalActionsContainer: FC<PropsWithChildren> = ({ children }) => {
    useLatestExchangeRates();
    usePrematchSports();
    useLiveSports();
    useSportResults();

    useEffect(() => {
        const navEntry = performance.getEntriesByType(
            "navigation",
        )[0] as PerformanceNavigationTiming;

        // Only scroll to top on reload, not on regular navigation
        if (navEntry?.type === "reload") {
            scrollToTop();
        }
    }, []);

    return children;
};

export default GlobalActionsContainer;
